const statusTypes = {
  ACTIVE: 'active',
  FAILED: 'failed',
  EXPIRY_SOON: 'expiry-soon',
  EXPIRED: 'expired',
};

export default statusTypes;
